module.exports = __webpack_public_path__ + "561d22ce83dddf9201d1cb7fc96585ed.jpg";